
export default class ProductRecommendations {
  constructor() {
    this.setup()
  }
  setup () {
    const ele = document.querySelector(".product-recommendations");

    fetch(ele.dataset.url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        ele.innerHTML = recommendations.innerHTML;
      }

      if (html.querySelector('.c-card')) {
        ele.classList.add('product-recommendations--loaded');
      }
    })
    .catch(e => {
      console.error(e);
    });
  }
}
